import { svg } from 'lit';

const symbol = svg`<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3.25" y="3.25" width="11.5" height="11.5" stroke="white" stroke-width="0.5"/>
</svg>`;

export { symbol as default };

